<template>
    <div class="indexPage">
        <div class="swiper mainSwiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="page page0">
                        <div class="left-textboxs center">
                            <div class="txt0 cnb">全新奥迪 <span class="en">Q5L</span></div>
                            <div class="txt1">豪华 <span class="en">B</span> 级 <span class="en">SUV</span> 智能新标杆</div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="page page1">
                        <div class="videoboxpc">
                            <video class="video" id="video0" controls preload="auto" src="../assets/videos/video6.mp4" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline x-webkit-airplay="allow"></video>
                            <div class="poster">
                                <div class="play"></div>
                            </div>
                        </div>

                        <div class="showm">
                            <div class="txt0 cnb">以全新姿态<br />赋全新旅程</div>
                            <div class="txt1 videobox">
                                <video class="video" id="video1" controls preload="auto" src="../assets/videos/video6.mp4" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline x-webkit-airplay="allow"></video>
                                <div class="poster">
                                    <div class="play"></div>
                                </div>
                            </div>
                            <div class="txt2">豪华燃油平台智驾先锋力量</div>
                        </div>

                        <div class="q5lbox">
                            <div class="q5l"></div>
                        </div>
                        <div class="tvcbox">
                            <div class="textboxs">
                                <div class="txt0 cnb">以全新姿态 赋全新旅程</div>
                                <div class="txt1">豪华燃油平台先锋力量</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="page page2">
                        <div class="left-textboxs">
                            <div class="txt0 cnb">
                                <div class="showpc">静态美学，掌控空间</div>
                                <div class="showm">静态美学<br />掌控空间</div>
                            </div>
                            <div class="txt1">以革新设计语言诠释动感与力量</div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="swiper horizontalSwiper horizontalSwiper0">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="page page3 page30">
                                    <div class="pagecon">
                                        <div class="textboxs">
                                            <div class="txt0 cnb">仿生灵感</div>
                                            <div class="txt1">前脸横向元素拉伸，营造低趴猎袭姿态</div>
                                        </div>
                                        <div class="txt2"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="page page3 page31">
                                    <div class="pagecon">
                                        <div class="textboxs">
                                            <div class="txt0 cnb">蓄势爆发</div>
                                            <div class="txt1">雕塑感肩线贯穿车身，勾勒动势基因</div>
                                        </div>
                                        <div class="txt2"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="page page3 page32">
                                    <div class="pagecon">
                                        <div class="textboxs">
                                            <div class="txt0 cnb">型格律动</div>
                                            <div class="txt1">
                                                <div class="showpc">
                                                    半隐藏式门把手设计<br />
                                                    诠释功能与美学的完美平衡
                                                </div>
                                                <div class="showm">半隐藏式门把手设计诠释功能与美学的完<br />美平衡</div>
                                            </div>
                                        </div>
                                        <div class="txt2"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="page page3 page33">
                                    <div class="pagecon">
                                        <div class="textboxs">
                                            <div class="txt0 cnb">极简雕琢</div>
                                            <div class="txt1">
                                                <div class="showpc">
                                                    贯穿式尾灯与悬浮后保险杠<br />
                                                    共同释放运动张力
                                                </div>
                                                <div class="showm">
                                                    贯穿式尾灯与悬浮后保险杠共同释放运动张力
                                                </div>
                                            </div>
                                        </div>
                                        <div class="txt2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="swiper horizontalSwiper horizontalSwiper1">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="page page4 page40">
                                    <div class="textboxs">
                                        <div class="txt0">光影矩阵</div>
                                        <div class="txt1">矩阵式 <span class="en">LED</span> 大灯，动态灯光签名重构未来视觉语言</div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="page page4 page41">
                                    <div class="textboxs top">
                                        <div class="txt0">交互新生</div>
                                        <div class="txt1">
                                            <div class="showpc">
                                                第二代数字 <span class="en">OLED</span> 尾灯，可实现<span class="en">266</span>个单元毫<br />秒级图像响应，并搭载中国专属的 <span class="en">quattro</span> 图<br />案投影式高位刹车灯，让视觉质感重塑新生
                                            </div>
                                            <div class="showm nowarp">
                                                第二代数字 <span class="en">OLED</span> 尾灯，可实现<span class="en">266</span>个单元<br />毫秒级图像响应，并搭载中国专属的 <span class="en">quattro</span><br />图案投影式高位刹车灯，让视觉质感重塑新生
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="page page4 page42">
                                    <div class="textboxs top">
                                        <div class="txt0">光幕徽标</div>
                                        <div class="txt1 nowrap">发光四环 <span class="en">LOGO</span>，以极简光效升华科技辨识度</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination white"></div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="page page5">
                        <div class="bg"></div>
                        <div class="textboxs">
                            <div class="txt0 cnb nowarp">兼顾美学与动力</div>
                            <div class="txt1">
                                <div class="showpc">全系标配 <span class="en">MHEVPLUS</span> 混动技术，搭配 <span class="en">2.0T</span> 动力+智能四驱系统，性能释放</div>
                                <div class="showm nowrap">全系标配 <span class="en">MHEVPLUS</span> 混动技术，搭配<br /><span class="en">2.0T</span> 动力+智能四驱系统，性能释放</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="page page6">
                        <div class="right-textboxs">
                            <div class="txt0 cnb">非凡未来</div>
                            <div class="txt1">
                                <div class="showpc">搭载华为乾崑技术组合驾驶辅助功能，安全与体验兼得</div>
                                <div class="showm">搭载华为乾崑技术组合驾驶辅助功能，安全与体验兼得</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="page page7">
                        <div class="image-grid">
                            <div class="cell cell-0">
                                <div class="img0box">
                                    <img src="../assets/index/page7_img0.jpg" idx="0" />
                                </div>
                                <div class="img1box">
                                    <img src="../assets/index/page7_img1.jpg" idx="7" />
                                </div>
                            </div>
                            <div class="cell cell-1">
                                <div class="row0">
                                    <div class="img0box">
                                        <img src="../assets/index/page7_img2.jpg" idx="1" />
                                    </div>
                                    <div class="img1box">
                                        <img src="../assets/index/page7_img3.jpg" idx="2" />
                                    </div>
                                </div>
                                <div class="row1">
                                    <div class="img0box">
                                        <img src="../assets/index/page7_img0.jpg" idx="-1" />
                                    </div>
                                </div>
                                <div class="row2">
                                    <div class="img0box">
                                        <img src="../assets/index/page7_img4.jpg" idx="6" />
                                    </div>
                                    <div class="img1box">
                                        <img src="../assets/index/page7_img5.jpg" idx="5" />
                                    </div>
                                </div>
                            </div>
                            <div class="cell cell-2">
                                <div class="img0box">
                                    <img src="../assets/index/page7_img6.jpg" idx="3" />
                                </div>
                                <div class="row1">
                                    <div class="img1box">
                                        <img src="../assets/index/page7_img7.jpg" idx="4" />
                                    </div>
                                    <div class="btn-next">
                                        <span>下一个</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="showm">
                            <div class="textboxs">
                                <div class="txt0 t0 cnb">锋行视界</div>
                                <div class="txt1 t1">更多车型美图 光影大赏</div>
                            </div>
                            <div class="txt2 swiperbox">
                                <div class="swiper horizontalSwiper horizontalSwiper2">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide"><img src="../assets/index/page7_img0.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img1.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img2.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img3.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img4.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img5.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img6.jpg" class="img" /></div>
                                        <div class="swiper-slide"><img src="../assets/index/page7_img7.jpg" class="img" /></div>
                                    </div>
                                    <div class="swiper-pagination black"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber } from '../utils/index'
export default {
    components: {},
    data() {
        return {}
    },
    created() {},
    mounted() {
        this.bindEvents()
    },
    beforeDestroy() {
        gsap.killTweensOf('*')
        console.log('清除动画')
    },
    destroyed() {},
    methods: {
        bindEvents() {
            $(window).scrollTop(0)
            var that = this
            gsap.killTweensOf('*')

            this.mainSwiperIndex = 0
            this.swiper0Index = 0
            this.swiper1Index = 0
            this.swiper2Index = 0

            setTimeout(() => {
                $(window).scrollTop(0)
                that.bindMainSwiper()
                setTimeout(() => {
                    that.bindHorizontalSwiper0()
                    that.bindHorizontalSwiper1()
                    that.bindHorizontalSwiper2()
                    that.bindPage7Event()
                })
            }, 300)
        },
        bindMainSwiper() {
            var that = this
            var swiper = new Swiper('.mainSwiper', {
                direction: 'vertical',
                slidesPerView: 1,
                mousewheel: true,
                allowTouchMove: true,
                speed: 500,
                on: {
                    init: function(swiper) {
                        that.initMainSwiper()
                    },
                    slideChangeTransitionEnd: function() {
                        that.onMainSwiperChangeEnd(this.activeIndex)
                    }
                }
            })
            this.mainSwiper = swiper
            // var swiper = new Swiper('.horizontalSwiper', {
            //     slidesPerView: 1,
            //     speed: 500
            // })
        },
        initMainSwiper() {
            console.log('initMainSwiper')
            var that = this
            this.setPage0()
            this.setPage1()
            setTimeout(() => {
                that.playPage0()
            }, 300)
            $('.page1 .poster').click(function() {
                that.playVideo0()
            })
        },
        onMainSwiperChangeEnd(idx) {
            this.mainSwiperIndex = idx
            console.log('onMainSwiperChangeEnd:' + idx)
            if (idx == 0) {
                this.setPage1()
                this.playPage0()
            } else if (idx == 1) {
                this.setPage2()
                this.setPage0()
                this.playPage1()
            } else if (idx == 2) {
                this.setPage1()
                this.initHorizontalSwiper0()
                this.playPage2()
            } else if (idx == 3) {
                this.setPage2()
                this.initHorizontalSwiper1()
                this.playHorizontalSwiper0()
            } else if (idx == 4) {
                this.initHorizontalSwiper0()
                this.setPage5()
                this.playHorizontalSwiper1()
            } else if (idx == 5) {
                this.initHorizontalSwiper1()
                this.setPage6()
                this.playPage5()
            } else if (idx == 6) {
                this.initHorizontalSwiper2()
                this.setPage7()
                this.setPage5()
                this.playPage6()
            } else if (idx == 7) {
                this.setPage6()
                this.playPage7()
            }
        },
        bindHorizontalSwiper0() {
            var that = this
            var swiper = new Swiper('.horizontalSwiper0', {
                speed: 500,
                spaceBetween: 0,
                pagination: {
                    el: '.horizontalSwiper0 .swiper-pagination',
                    clickable: true
                },
                on: {
                    init: function(swiper) {
                        that.initHorizontalSwiper0()
                    },
                    slideChangeTransitionEnd: function() {
                        that.onSwiper0SwiperChangeEnd(this.activeIndex)
                    }
                }
            })
            this.horizontalSwiper0 = swiper
        },
        initHorizontalSwiper0() {
            console.log('initHorizontalSwiper0')
            if (this.horizontalSwiper0) {
                this.horizontalSwiper0.slideTo(0, 0, false)
                this.swiper0Index = 0
            }
            this.setPage30()
            this.setPage31()
            this.setPage32()
            this.setPage33()
        },
        playHorizontalSwiper0() {
            if (this.swiper0Index == 0) {
                this.setPage31()
                this.setPage32()
                this.setPage33()
                this.playPage30()
            } else if (this.swiper0Index == 1) {
                this.setPage30()
                this.setPage32()
                this.setPage33()
                this.playPage31()
            } else if (this.swiper0Index == 2) {
                this.setPage31()
                this.setPage30()
                this.setPage33()
                this.playPage32()
            } else {
                this.setPage31()
                this.setPage30()
                this.setPage32()
                this.playPage33()
            }
        },
        onSwiper0SwiperChangeEnd(idx) {
            this.swiper0Index = idx
            this.playHorizontalSwiper0()
        },

        bindHorizontalSwiper1() {
            var that = this
            var swiper = new Swiper('.horizontalSwiper1', {
                speed: 500,
                spaceBetween: 0,
                pagination: {
                    el: '.horizontalSwiper1 .swiper-pagination',
                    clickable: true
                },
                on: {
                    init: function(swiper) {
                        that.initHorizontalSwiper1()
                    },
                    slideChangeTransitionEnd: function() {
                        that.onSwiper1SwiperChangeEnd(this.activeIndex)
                    }
                }
            })
            this.horizontalSwiper1 = swiper
        },
        initHorizontalSwiper1() {
            console.log('initHorizontalSwiper1')
            if (this.horizontalSwiper1) {
                this.horizontalSwiper1.slideTo(0, 0, false)
                this.swiper1Index = 0
            }
            this.setPage40()
            this.setPage41()
            this.setPage42()
        },
        playHorizontalSwiper1() {
            if (this.swiper1Index == 0) {
                this.setPage41()
                this.setPage42()
                this.playPage40()
            } else if (this.swiper1Index == 1) {
                this.setPage40()
                this.setPage42()
                this.playPage41()
            } else if (this.swiper1Index == 2) {
                this.setPage40()
                this.setPage41()
                this.playPage42()
            }
        },
        onSwiper1SwiperChangeEnd(idx) {
            this.swiper1Index = idx
            this.playHorizontalSwiper1()
        },

        bindHorizontalSwiper2() {
            var that = this
            var swiper = new Swiper('.horizontalSwiper2', {
                speed: 500,
                spaceBetween: 0,
                pagination: {
                    el: '.horizontalSwiper2 .swiper-pagination',
                    clickable: true
                },
                on: {
                    init: function(swiper) {
                        that.initHorizontalSwiper2()
                    },
                    slideChangeTransitionEnd: function() {
                        that.onSwiper2SwiperChangeEnd(this.activeIndex)
                    }
                }
            })
            this.horizontalSwiper2 = swiper
        },
        initHorizontalSwiper2() {
            console.log('initHorizontalSwiper2')
            if (this.horizontalSwiper2) {
                this.horizontalSwiper2.slideTo(0, 0, false)
                this.swiper2Index = 0
            }
        },
        playHorizontalSwiper2() {},
        onSwiper2SwiperChangeEnd(idx) {
            this.swiper2Index = idx
            this.playHorizontalSwiper2()
        },

        setPage0() {
            for (var i = 0; i <= 1; i++) {
                gsap.killTweensOf('.page0 .txt' + i)
            }
            for (var i = 0; i <= 1; i++) {
                gsap.set('.page0 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage0() {
            for (var i = 0; i <= 1; i++) {
                gsap.to('.page0 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },
        setPage1() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page1 .showm .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page1 .showm .txt' + i, { opacity: 0, y: 100 })
            }

            gsap.killTweensOf('.page1 .tvcbox')
            gsap.killTweensOf('.page1 .q5lbox')
            gsap.killTweensOf('.page1 .poster')
            gsap.set('.page1 .tvcbox', { opacity: 1, display: 'block' })
            gsap.set('.page1 .q5lbox', { opacity: 1, scale: 1, display: 'block' })
            gsap.set('.page1 .poster', { opacity: 1, display: 'block' })
            $('.page1 .tvcbox .txt0').css({ background: 'linear-gradient(90deg, #fff 0%, #2f2f2f 100%)', 'background-clip': 'text' })
            $('.page1 .tvcbox .txt1').css({ background: 'linear-gradient(90deg, #404040 0%, #fff 100%)', 'background-clip': 'text' })
            try {
                $('#video0')[0].pause()
            } catch (e) {}
            try {
                $('#video1')[0].pause()
            } catch (e) {}
        },
        playVideo0() {
            $('.page1 .poster').fadeOut()
            if ($(window).width() <= 768) {
                try {
                    $('#video1')[0].play()
                } catch (e) {}
            } else {
                try {
                    $('#video0')[0].play()
                } catch (e) {}
            }
        },
        playPage1Anim0() {
            var that = this
            this.page1Anim0 = gsap.to('.page1 .tvcbox', 0.7, {
                ease: 'none',
                onUpdate: () => {
                    var p = that.page1Anim0.progress()
                    var x = p * 2 * 100
                    $('.page1 .tvcbox .txt0').css({ background: 'linear-gradient(90deg, #fff ' + x + '%, #2f2f2f 100%)', 'background-clip': 'text' })
                    var x2 = 100 - p * 2 * 100
                    $('.page1 .tvcbox .txt1').css({ background: 'linear-gradient(90deg, #404040 0%, #fff ' + x2 + '%)', 'background-clip': 'text' })
                }
            })
            gsap.to('.page1 .tvcbox', 0.5, { opacity: 0, display: 'none', delay: 0.7, ease: 'none' })
            gsap.to('.page1 .q5lbox', 1, { opacity: 0, scale: 6, display: 'none', delay: 1.5, ease: 'none' })
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page1 .showm .txt' + i, { opacity: 1, y: 0, delay: 1.7 + 0.2 * i })
            }
        },
        playPage1() {
            this.playPage1Anim0()
        },
        setPage2() {
            for (var i = 0; i <= 1; i++) {
                gsap.killTweensOf('.page2 .txt' + i)
            }
            for (var i = 0; i <= 1; i++) {
                gsap.set('.page2 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage2() {
            for (var i = 0; i <= 1; i++) {
                gsap.to('.page2 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },

        setPage30() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page30 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page30 .txt' + i, { opacity: 0, y: 100 })
            }
            if ($(window).width() <= 768) {
                gsap.set('.page30 .txt2', { opacity: 1, y: 0 })
            }
        },
        playPage30() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page30 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },
        setPage31() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page31 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page31 .txt' + i, { opacity: 0, y: 100 })
            }
            if ($(window).width() <= 768) {
                gsap.set('.page31 .txt2', { opacity: 1, y: 0 })
            }
        },
        playPage31() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page31 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },
        setPage32() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page32 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page32 .txt' + i, { opacity: 0, y: 100 })
            }
            if ($(window).width() <= 768) {
                gsap.set('.page32 .txt2', { opacity: 1, y: 0 })
            }
        },
        playPage32() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page32 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },
        setPage33() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page33 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page33 .txt' + i, { opacity: 0, y: 100 })
            }
            if ($(window).width() <= 768) {
                gsap.set('.page33 .txt2', { opacity: 1, y: 0 })
            }
        },
        playPage33() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page33 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },

        setPage40() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page40 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page40 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage40() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page40 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },
        setPage41() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page41 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page41 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage41() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page41 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },
        setPage42() {
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page42 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage42() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page42 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page42 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },

        setPage5() {
            for (var i = 0; i <= 1; i++) {
                gsap.killTweensOf('.page5 .showm .txt' + i)
            }
            for (var i = 0; i <= 1; i++) {
                gsap.set('.page5 .showm .txt' + i, { opacity: 0, y: 100 })
            }
            gsap.killTweensOf('.page5 .txt0')
            gsap.killTweensOf('.page5 .txt1')
            $('.page5 .txt0').css({ background: 'linear-gradient(90deg, #fff 0%, #2f2f2f 100%)', 'background-clip': 'text' })
            $('.page5 .txt1').css({ background: 'linear-gradient(90deg, #404040 0%, #fff 100%)', 'background-clip': 'text' })
            $('.page5').removeClass('active')
        },
        playPage5() {
            var that = this
            if ($(window).width <= 768) {
                for (var i = 0; i <= 1; i++) {
                    gsap.to('.page5 .showm .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
                }
            } else {
                this.page5Anim0 = gsap.to('.page5 .txt0', 0.8, {
                    ease: 'none',
                    onUpdate: () => {
                        var p = that.page5Anim0.progress()
                        var x = p * 2 * 100
                        $('.page5 .txt0').css({ background: 'linear-gradient(90deg, #fff ' + x + '%, #2f2f2f 100%)', 'background-clip': 'text' })
                        var x2 = 100 - p * 2 * 100
                        $('.page5 .txt1').css({ background: 'linear-gradient(90deg, #404040 0%, #fff ' + x2 + '%)', 'background-clip': 'text' })
                    },
                    onComplete: () => {
                        $('.page5').addClass('active')
                    }
                })
            }
        },

        setPage6() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page6 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page6 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage6() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page6 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },

        setPage7() {
            for (var i = 0; i <= 2; i++) {
                gsap.killTweensOf('.page7 .txt' + i)
            }
            for (var i = 0; i <= 2; i++) {
                gsap.set('.page7 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        playPage7() {
            for (var i = 0; i <= 2; i++) {
                gsap.to('.page7 .txt' + i, { opacity: 1, y: 0, delay: 0.2 * i })
            }
        },

        bindPage7Event() {
            var that = this
            this.page4SelectIndex = 0
            var imageList = []
            $('.image-grid img').each(function(i, el) {
                var idx = parseInt($(el).attr('idx'))
                if (idx >= 0) {
                    var src = $(el).attr('src')
                    imageList.push({
                        idx: idx,
                        src: src,
                        target: el
                    })
                    $(el).click(function() {
                        $('.image-grid img').removeClass('active')
                        $(el).addClass('active')
                        that.page4SelectIndex = idx
                        $('.image-grid .cell-1 .row1 img').attr('src', src)
                    })
                }
            })
            $('.image-grid .btn-next').click(function() {
                that.page4SelectIndex++
                if (that.page4SelectIndex >= 8) {
                    that.page4SelectIndex = 0
                }
                var item = imageList.find((it) => {
                    return it.idx == that.page4SelectIndex
                })
                if (item) {
                    item.target.click()
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.indexPage {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #fef7ee;
    * {
        font-family: 'audi-wide';
    }
    .en {
        font-family: 'AudiTypeGBNormal';
    }
    .cnb {
        font-family: 'audi-zh-bold';
        .en {
            font-family: 'AudiTypeGBWideBold';
        }
    }
    .showpc {
        display: block;
        @media only screen and (max-width: 768px) {
            display: none;
        }
    }
    .showm {
        display: none;
        @media only screen and (max-width: 768px) {
            display: block;
        }
    }
    .nowrap {
        word-break: normal;
        white-space: nowrap;
        word-spacing: normal;
    }
    .page {
        width: 100vw;
        height: 100vh;
        background-color: #47504f;
        position: relative;
        left: 0;
        top: 0;

        color: #fff;
        .bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
            overflow: hidden;
        }
        .left-textboxs {
            position: absolute;
            left: 120px;
            top: 150px;
            z-index: 3;
            @media only screen and (max-width: 768px) {
                left: (30vw/3.75);
                top: (120vw/3.75);
                right: (30vw/3.75);
                &.center {
                    text-align: center;
                }
            }
            .txt0 {
                font-size: 70px;
                line-height: 80px;
                margin-bottom: 24px;
                @media only screen and (max-width: 768px) {
                    font-size: (38vw/3.75);
                    line-height: (46vw/3.75);
                    margin-bottom: (30vw/3.75);
                }
            }
            .txt1 {
                font-size: 30px;
                line-height: 45px;
                @media only screen and (max-width: 768px) {
                    font-size: (16vw/3.75);
                    line-height: (24vw/3.75);
                }
            }
        }
        .right-textboxs {
            position: absolute;
            right: 120px;
            top: 150px;
            z-index: 3;
            text-align: right;
            @media only screen and (max-width: 768px) {
                right: (30vw/3.75);
                top: (120vw/3.75);
            }
            .txt0 {
                font-size: 70px;
                line-height: 80px;
                margin-bottom: 24px;
                @media only screen and (max-width: 768px) {
                    font-size: (38vw/3.75);
                    line-height: (46vw/3.75);
                    margin-bottom: (30vw/3.75);
                }
            }
            .txt1 {
                font-size: 30px;
                line-height: 45px;
                @media only screen and (max-width: 768px) {
                    font-size: (16vw/3.75);
                    line-height: (24vw/3.75);
                }
            }
        }
    }
    .page0 {
        background: url(../assets/index/page0_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page0_bg_m.jpg) no-repeat center top;
            background-size: 100% auto;
        }
        .left-textboxs {
            .txt0 {
                opacity: 0;
                @media only screen and (max-width: 768px) {
                    font-size: (32vw/3.75);
                    line-height: (51vw/3.75);
                    margin-bottom: (5vw/3.75);
                }
            }
            .txt1 {
                opacity: 0;
                @media only screen and (max-width: 768px) {
                    font-size: (20vw/3.75);
                    line-height: (32vw/3.75);
                }
            }
        }
    }

    .page1 {
        background: #fef7ee;

        .tvcbox {
            width: 100%;
            height: 100%;
            position: absolute;
            background-color: #000;
            z-index: 30;
            left: 0;
            top: 0;
            .textboxs {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateY(-50%) translateX(-50%);
                text-align: center;
                width: 100%;

                .txt0 {
                    font-size: 80px;
                    line-height: 96px;
                    color: #fff;
                    background: linear-gradient(90deg, #fff 0%, #2f2f2f 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin: 0 auto;
                    margin-bottom: 26px;
                    width: 830px;
                    @media only screen and (max-width: 768px) {
                        font-size: (38vw/3.75);
                        line-height: (46vw/3.75);
                        margin-bottom: (21vw/3.75);
                        width: (190vw/3.75);
                    }
                }
                .txt1 {
                    font-size: 40px;
                    line-height: 48px;
                    color: #fff;
                    background: linear-gradient(90deg, #404040 0%, #fff 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    width: 540px;
                    margin: 0 auto;
                    @media only screen and (max-width: 768px) {
                        font-size: (18vw/3.75);
                        line-height: (22vw/3.75);
                        width: (216vw/3.75);
                    }
                }
            }
        }
        .q5lbox {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 20;
            left: 0;
            top: 0;
            .q5l {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: url(../assets/index/page1_q5l2.png) no-repeat center center;
                background-size: cover;
                z-index: 3;
                @media only screen and (max-width: 768px) {
                    background: url(../assets/index/page1_q5l2_m.png) no-repeat center center;
                    background-size: cover;
                }
            }
        }
        .videoboxpc {
            width: 100%;
            height: 100%;
            position: absolute;
            background-color: #000;
            z-index: 10;
            left: 0;
            top: 0;
            @media only screen and (max-width: 768px) {
                display: none;
            }
            .video {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 0;
                background-color: #000;
                object-fit: cover;
            }
            .poster {
                width: 100%;
                height: 100%;
                background: url(../assets/videos/poster.jpg) no-repeat center center;
                background-size: cover;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                cursor: pointer;
                .play {
                    width: 140px;
                    height: 140px;
                    background: url(../assets/index/play2.png) no-repeat center center;
                    background-size: cover;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    pointer-events: none;
                    opacity: 0.9;
                }
            }
        }

        .showm {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-color: #fcf5ee;
            z-index: 15;
            display: none;
            @media only screen and (max-width: 768px) {
                display: block;
            }
            .txt0 {
                padding: (110vw/3.75) 0 (55vw/3.75) (30vw/3.75);
                font-size: (38vw/3.75);
                line-height: (46vw/3.75);
                color: #000;
            }
            .videobox {
                width: 100%;
                height: (216vw/3.75);
                background-color: #000;
                position: relative;
                .video {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 0;
                    background-color: #000;
                    object-fit: cover;
                }
                .poster {
                    width: 100%;
                    height: 100%;
                    background: url(../assets/videos/poster.jpg) no-repeat center center;
                    background-size: cover;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 1;
                    cursor: pointer;
                    .play {
                        width: (58vw/3.75);
                        height: (58vw/3.75);
                        background: url(../assets/index/play2.png) no-repeat center center;
                        background-size: cover;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        pointer-events: none;
                    }
                }
            }
            .txt2 {
                padding: (58vw/3.75) (30vw/3.75) (30vw/3.75) (30vw/3.75);
                font-size: (16vw/3.75);
                line-height: (24vw/3.75);
                color: #000;
            }
        }
    }

    .page2 {
        background: url(../assets/index/page2_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page2_bg_m.jpg) no-repeat center center;
            background-size: 100% auto;
        }
        .left-textboxs {
            color: #000;
            @media only screen and (max-width: 768px) {
                color: #fff;
                top: auto;
                bottom: 0;
                .txt1 {
                    margin-bottom: (87vw/3.75);
                }
            }
        }
    }

    .page3 {
        background-color: #fff;
        .pagecon {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            @media only screen and (max-width: 768px) {
                width: 100%;
                height: 100%;
            }

            .textboxs {
                width: 814px;
                padding-top: 184px;
                padding-left: 120px;
                box-sizing: border-box;
                color: #000;
                z-index: 20;
                @media only screen and (max-width: 768px) {
                    position: absolute;
                    width: auto;
                    padding-top: (80vw/3.75);
                    padding-left: (30vw/3.75);
                }
                .txt0 {
                    font-size: 72px;
                    line-height: 86px;
                    margin-bottom: 30px;
                    @media only screen and (max-width: 768px) {
                        font-size: (38vw/3.75);
                        line-height: (46vw/3.75);
                        margin-bottom: (30vw/3.75);
                    }
                }
                .txt1 {
                    font-size: 30px;
                    line-height: 45px;
                    @media only screen and (max-width: 768px) {
                        font-size: (16vw/3.75);
                        line-height: (24vw/3.75);
                    }
                }
            }
            .txt2 {
                width: 1106px;
                height: 692px;
                @media only screen and (max-width: 768px) {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .page30 {
        .txt2 {
            background: url(../assets/index/page30_bg.jpg) no-repeat left center;
            background-size: cover;
            @media only screen and (max-width: 768px) {
                background: url(../assets/index/page30_bg_m.jpg) no-repeat left top;
                background-size: 100% auto;
            }
        }
    }
    .page31 {
        .txt2 {
            background: url(../assets/index/page31_bg.jpg) no-repeat left center;
            background-size: cover;
            @media only screen and (max-width: 768px) {
                background: url(../assets/index/page31_bg_m.jpg) no-repeat left top;
                background-size: 100% auto;
            }
        }
    }
    .page32 {
        .txt2 {
            background: url(../assets/index/page32_bg.jpg) no-repeat left center;
            background-size: cover;
            @media only screen and (max-width: 768px) {
                background: url(../assets/index/page32_bg_m.jpg) no-repeat left top;
                background-size: 100% auto;
            }
        }
    }
    .page33 {
        .txt2 {
            background: url(../assets/index/page33_bg.jpg) no-repeat left center;
            background-size: cover;
            @media only screen and (max-width: 768px) {
                background: url(../assets/index/page33_bg_m.jpg) no-repeat left top;
                background-size: 100% auto;
            }
        }
    }

    .page4 {
        .textboxs {
            padding-top: 1px;
            width: 814px;
            padding-left: 120px;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 10;
            @media only screen and (max-width: 768px) {
                width: auto;
                padding-left: (30vw/3.75);
                padding-right: (30vw/3.75);
            }
            &.top {
                margin-top: 160px;
                top: 0;
                bottom: auto;
                @media only screen and (max-width: 768px) {
                    margin-top: 0;
                    top: auto;
                    bottom: 0;
                }
            }
            .txt0 {
                font-size: 72px;
                line-height: 86px;
                margin-bottom: 30px;
                @media only screen and (max-width: 768px) {
                    font-size: (38vw/3.75);
                    line-height: (46vw/3.75);
                    margin-bottom: (30vw/3.75);
                }
            }
            .txt1 {
                font-size: 30px;
                line-height: 45px;
                margin-bottom: 160px;
                @media only screen and (max-width: 768px) {
                    font-size: (16vw/3.75);
                    line-height: (25vw/3.75);
                    margin-bottom: (116vw/3.75);
                }
            }
        }
    }
    .page40 {
        background: url(../assets/index/page40_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page40_bg_m.jpg) no-repeat left top;
            background-size: 100% auto;
        }
    }
    .page41 {
        background: url(../assets/index/page41_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page41_bg_m.jpg) no-repeat left top;
            background-size: 100% auto;
        }
    }
    .page42 {
        background: url(../assets/index/page42_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page42_bg_m.jpg) no-repeat left top;
            background-size: 100% auto;
        }
    }

    .page5 {
        background: url(../assets/index/page5_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page5_bg_m.jpg) no-repeat left top;
            background-size: 100% auto;
        }
        &.active {
            .bg {
                opacity: 0;
            }
            .textboxs {
                left: 120px;
                top: 150px;
                transform: translateX(0);
                @media only screen and (max-width: 768px) {
                    left: (30vw/3.75);
                    top: (80vw/3.75);
                }
                .txt0 {
                    font-size: 70px;
                    line-height: 80px;
                    margin-bottom: 24px;
                    width: 517px;
                    @media only screen and (max-width: 768px) {
                        width: (270vw/3.75);
                        font-size: (38vw/3.75);
                        line-height: (46vw/3.75);
                        margin-bottom: (30vw/3.75);
                    }
                }
                .txt1 {
                    font-size: 30px;
                    line-height: 45px;
                    width: 600px;
                    @media only screen and (max-width: 768px) {
                        width: 100%;
                        font-size: (16vw/3.75);
                        line-height: (25vw/3.75);
                        margin-bottom: (0vw/3.75);
                    }
                }
            }
        }
        .bg {
            background-color: #000;
            transition: all 0.5s;
        }
        .textboxs {
            position: absolute;
            top: 50%;
            z-index: 30;
            transition: all 0.5s;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            .txt0 {
                font-size: 80px;
                line-height: 96px;
                color: #fff;
                background: linear-gradient(90deg, #fff 0%, #2f2f2f 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin-bottom: 26px;
                transition: all 0.5s;
                width: 100%;
                text-align: center;
                @media only screen and (max-width: 768px) {
                    font-size: (38vw/3.75);
                    line-height: (46vw/3.75);
                    margin-bottom: (30vw/3.75);
                }
            }
            .txt1 {
                font-size: 30px;
                line-height: 37px;
                color: #fff;
                background: linear-gradient(90deg, #404040 0%, #fff 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                transition: all 0.5s;
                width: 1025px;
                @media only screen and (max-width: 768px) {
                    width: (270vw/3.75);
                    font-size: (16vw/3.75);
                    line-height: (25vw/3.75);
                    margin-bottom: (0vw/3.75);
                }
            }
        }
    }
    .page6 {
        background: url(../assets/index/page6_bg.jpg) no-repeat center center;
        background-size: cover;
        @media only screen and (max-width: 768px) {
            background: url(../assets/index/page6_bg_m.jpg) no-repeat left top;
            background-size: 100% auto;
        }
        @media only screen and (max-width: 768px) {
            .right-textboxs {
                text-align: left;
                right: (30vw/3.75);
                left: (30vw/3.75);
            }
        }
    }
    .page7 {
        background-color: #000;
        z-index: 6;
        .image-grid {
            position: absolute;
            left: 0;
            top: 0px;
            right: 0;
            bottom: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            @media only screen and (max-width: 768px) {
                display: none;
            }
            .cell-0 {
                width: 324px;
                height: 100%;
                .img0box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
                .img1box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
            }
            .cell-1 {
                width: 1272px;
                height: 100%;
                display: flex;
                flex-direction: column;
                .row0 {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 125px;
                    flex-shrink: 0;
                    .img0box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .img1box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                }
                .row1 {
                    width: 100%;
                    height: calc(100% - 250px);
                    .img0box {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
                .row2 {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 125px;
                    flex-shrink: 0;
                    .img0box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .img1box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                }
            }
            .cell-2 {
                width: 324px;
                height: 100%;
                .img0box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
                .row1 {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    .img1box {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .btn-next {
                        width: 100%;
                        height: 127px;
                        background-color: #000;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        flex-shrink: 0;
                        cursor: pointer;
                        span {
                            font-size: 18px;
                            line-height: 1.2;
                            background: url(../assets/index/page4_arrow.png) no-repeat right center;
                            background-size: auto 20px;
                            padding-right: 25px;
                        }
                    }
                }
            }
        }

        .showm {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-color: #fcf5ee;
            .textboxs {
                width: 100%;
                height: (240vw/3.75);
                padding-left: (30vw/3.75);
                .t0 {
                    padding: (80vw/3.75) 0 (30vw/3.75) (0vw/3.75);
                    font-size: (38vw/3.75);
                    line-height: (46vw/3.75);
                    color: #000;
                }
                .t1 {
                    font-size: (16vw/3.75);
                    line-height: (24vw/3.75);
                    color: #000;
                }
            }

            .swiperbox {
                width: 100%;
                position: absolute;
                left: 0;
                top: (240vw/3.75);
                right: 0;
                bottom: 0;
                overflow: hidden;
                .img {
                    width: 100%;
                    height: (280vw/3.75);
                    object-fit: cover;
                }
            }
        }
    }
}

>>> .swiper-pagination {
    height: 6px;
    bottom: 40px;
    width: 100%;
    .swiper-pagination-bullet {
        width: 40px;
        height: 6px;
        margin: 0 6px;
        border-radius: 0;
        background-color: #000;
        opacity: 0.3;
        &.swiper-pagination-bullet-active {
            opacity: 1;
        }
    }
    &.white {
        .swiper-pagination-bullet {
            background-color: #fff;
        }
    }
    @media only screen and (max-width: 768px) {
        height: 6px;
        bottom: 90px;
        width: 100%;
        .swiper-pagination-bullet {
            width: 30px;
            height: 6px;
            margin: 0 6px;
            border-radius: 0;
            background-color: #fff;
            opacity: 0.3;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
        &.black {
            .swiper-pagination-bullet {
                background-color: #000;
            }
        }
    }
}
.gif {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    object-fit: cover;
}
.gifmask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/indexnew.vue